<div class="background">
  <div class="register-container">
    <p class="body-bold-20 register-title">
      {{'general.create_an_account' | translate}}
    </p>
    <p class="bordered mb-24"></p>

    <form class="flex-form" [formGroup]="registerForm" (ngSubmit)="submit()">
      <div class="inline-forms">
        <div class="form-outline">
          <app-text-input
            id="business-firstName"
            name="firstName"
            [label]="'general.firstname' | translate"
            [errorMessage]="'errors.invalid_firstname' | translate"
            [showError]="firstName.invalid && formSubmitAttempt"
            formControlName="firstName">
          </app-text-input>
          <ng-container *ngFor="let message of getServerErrors('firstName') | slice: 0:1">
            <span class="error-text">{{ message }}</span>
          </ng-container>
        </div>

        <div class="form-outline">
          <app-text-input
            id="business-lastName"
            name="lastName"
            [label]="'general.lastname' | translate"
            [errorMessage]="'errors.invalid_lastname' | translate"
            [showError]="lastName.invalid && formSubmitAttempt"
            formControlName="lastName">
          </app-text-input>
          <ng-container *ngFor="let message of getServerErrors('lastName') | slice: 0:1">
            <span class="error-text">{{ message }}</span>
          </ng-container>
        </div>
      </div>

      <div class="inline-forms">
        <div class="form-outline">
          <app-text-input
            id="business-email"
            name="email"
            type="email"
            [label]="'general.email' | translate"
            [errorMessage]="'errors.invalid_email' | translate"
            [showError]="email.invalid && formSubmitAttempt"
            formControlName="email">
          </app-text-input>
          <ng-container *ngFor="let message of getServerErrors('email') | slice: 0:1">
            <span class="error-text">{{ message }}</span>
          </ng-container>
        </div>

        <div class="form-outline">
          <label for="phone">{{'general.phone' | translate}}</label>
          <my-phone [formGroup]="registerForm"></my-phone>
        </div>
      </div>

      <div class="inline-forms">
        <div class="form-outline">
          <app-text-input
            id="business-name"
            name="businessName"
            [label]="'general.business_name' | translate"
            [errorMessage]="'errors.invalid_business_name' | translate"
            [showError]="businessName.invalid && formSubmitAttempt"
            formControlName="businessName">
          </app-text-input>
          <ng-container *ngFor="let message of getServerErrors('businessName') | slice: 0:1">
            <span class="error-text">{{ message }}</span>
          </ng-container>
        </div>
      </div>

      <div class="inline-forms">
        <div class="form-outline">
          <app-text-input
            id="business-password"
            name="password"
            type="password"
            [label]="'general.password' | translate"
            [enablePasswordToggle]="true"
            [errorMessage]="'errors.invalid_password' | translate"
            [showError]="password.invalid && formSubmitAttempt"
            formControlName="password">
          </app-text-input>
          <ng-container *ngFor="let message of getServerErrors('password') | slice: 0:1">
            <span class="error-text">{{ message }}</span>
          </ng-container>
        </div>

        <div class="form-outline">
          <app-text-input
            id="business-confirm-password"
            name="confirmPassword"
            type="password"
            [label]="'general.confirm_password' | translate"
            [enablePasswordToggle]="true"
            [errorMessage]="'errors.invalid_password' | translate"
            [showError]="confirmPassword.invalid && formSubmitAttempt"
            formControlName="confirmPassword">
          </app-text-input>
          <span *ngIf="formSubmitAttempt && confirmPassword.valid && registerForm.hasError('passwordMatch')" class="error-text">
            {{'errors.passwords_dont_match' | translate}}
          </span>
          <ng-container *ngFor="let message of getServerErrors('confirmPassword') | slice: 0:1">
            <span class="error-text">{{ message }}</span>
          </ng-container>
        </div>
      </div>

      <ng-container *ngFor="let message of getServerErrors('general') | slice: 0:1">
        <span class="error-text register-general-error">{{ message }}</span>
      </ng-container>

      <div class="form-outline flex center register-actions">
        <button type="submit" class="primary-blue-500 full-width" id="signin-button" [disabled]="isSubmitting">
          <span *ngIf="isSubmitting" class="spinner-border spinner-border-sm me-2" role="status" aria-hidden="true"></span>
          {{'general.create_account' | translate}}
        </button>
      </div>
    </form>

    <div class="f-d-c center gap-6">
      <div class="text-center">
        <span class="vector4-long" id="left-vector"></span>
        <span class="body14">{{'general.use_social_options' | translate}}</span>
        <span class="vector4-long" id="right-vector"></span>
      </div>
      <div class="flex center flex-row">
        <button type="button" class="social-auth-button" (click)="signUpWithGoogle()">
          <span class="google-icon"></span>
          <span class="body14 hide-when-small">{{'general.google' | translate}}</span>
        </button>
      </div>
    </div>
  </div>
</div>
